export default __webpack_public_path__ + "maps-examples-heatmap-example-thumbnail-480-378577ac910ddc8c0c56257c1b56ed9d.webp";